<!--无权限提示-->
<template>
  <div :class="[isPc ? 'noauth-box-pc' : 'noauth-box']">
    <van-dialog v-model="noauthShow" :show-confirm-button="false" :width="isPc?'7.36rem':'3.36rem'">
      <template #default>
        <div class="noauth-content">
          <div class="title">{{ content.noauthTip }}</div>
          <div class="noauth-p">
            {{ content.noauthDesc }}
          </div>
          <van-button type="info" round class="noauthBtn" color="linear-gradient(to right, #2A8AFA, #72C9FF)" @click="noauthBtn">{{
            content.noauthBtn
          }}</van-button>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      noauthShow: false // 弹窗
    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  methods: {
    // 弹出
    showDialog() {
      this.noauthShow = true
    },
    // 按钮
    noauthBtn() {
      this.noauthShow = false
      this.$emit('ensure')
    }
  }
}
</script>

<style lang="less" scoped>
.van-dialog {
  border-radius: 6px;
}
.noauth-box-pc{
  .noauth-content {
    padding: 0 0.55rem;
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.33rem;
      margin-bottom: 0.2rem;
    }
    .noauth-p {
      max-height: 3.67rem;
      min-height: 1rem;
      overflow-y: auto;
      font-size: 0.19rem;
      color: #666666;
      line-height: 0.25rem;
      /deep/pre {
        white-space: pre-wrap;
        margin: 0;
      }
    }
    .noauth-check {
      margin-top: 0.15rem;
    }
    /deep/.van-icon{
      line-height: 1;
    }
    /deep/.van-checkbox__label {
      font-size: 0.16rem;
    }
    .noauthBtn {
      width: 2.8rem;
      height: 0.55rem;
      margin: 0.15rem auto 0.3rem;
      display: block;
    }
  }
}
.noauth-box {
  .noauth-content {
    padding: 0 0.25rem;
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
    }
    .noauth-p {
      max-height: 3.67rem;
      overflow-y: auto;
      font-size: 0.15rem;
      color: #666666;
      line-height: 0.25rem;
      /deep/pre {
        white-space: pre-wrap;
        margin: 0;
      }
    }
    .noauth-check {
      margin-top: 0.05rem;
    }
    /deep/.van-checkbox__label {
      font-size: 0.16rem;
    }
    .noauthBtn {
      width: 2.8rem;
      height: 0.45rem;
      margin: 0.15rem auto 0.25rem;
      display: block;
    }
  }
}
</style>
